<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`报销详情`"
    width="900px"
    height="600px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form v-loading="editLoading" disabled :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="12">
          <el-form-item label="日期" prop="occTime">
            <el-date-picker
              v-model="editForm.occTime"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="地点" prop="address">
            <el-input v-model.trim="editForm.address" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="交通费" prop="exp1">
            <el-input type="number" v-model.trim="editForm.exp1" placeholder="请输入">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="住宿费" prop="exp2">
            <el-input type="number" v-model.trim="editForm.exp2" placeholder="请输入">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="租车费" prop="exp3">
            <el-input type="number" v-model.trim="editForm.exp3" placeholder="请输入">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="油费" prop="exp4">
            <el-input type="number" v-model.trim="editForm.exp4" placeholder="请输入">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="过路费" prop="exp5">
            <el-input type="number" v-model.trim="editForm.exp5" placeholder="请输入">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="招待费" prop="exp6">
            <el-input type="number" v-model.trim="editForm.exp6" placeholder="请输入">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="其他" prop="expOther">
            <el-input type="number" v-model.trim="editForm.expOther" placeholder="请输入">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="招待人员" prop="clientname">
            <el-input v-model.trim="editForm.clientname" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="费用备注" prop="remark">
            <el-input v-model.trim="editForm.remark" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报销人" prop="userName">
            <el-input v-model.trim="editForm.userName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="报销凭证">
            <div class="img-list">
              <el-image
                v-for="(url, imgIndex) in editForm.imgList"
                :key="imgIndex"
                style="width: 88px; height: 88px"
                :src="url"
                :preview-src-list="editForm.imgList"
              ></el-image>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { getRmbsm } from '@/api/expense';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      editLoading: false,
      editForm: {},
      rules: {
        occTime: [{ required: true, message: '请选择时间', trigger: 'change' }],
        address: [{ required: true, message: '请输入地点', trigger: 'blur' }]
      },
      submitLoading: false
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val && this.activeId) {
        this.getDetailData();
      }
    }
  },
  methods: {
    async getDetailData() {
      this.editLoading = true;
      try {
        const { data } = await getRmbsm({ id: this.activeId });
        this.editForm = {
          id: data.id,
          occTime: data.occTime,
          address: data.address,
          exp1: data.exp1,
          exp2: data.exp2,
          exp3: data.exp3,
          exp4: data.exp4,
          exp5: data.exp5,
          exp6: data.exp6,
          exp7: data.exp7,
          expOther: data.expOther,
          clientname: data.clientname,
          remark: data.remark,
          pics: data.pics,
          userName: data.userName
        };
        if (data.pics) {
          this.editForm.imgList = data.pics.split(',').map(item => {
            return this.$imgUrl + item;
          });
        } else {
          this.editForm.imgList = [];
        }
      } finally {
        this.editLoading = false;
      }
    }
  },
  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.el-select,
.el-input,
.el-autocomplete {
  width: 100%;
}
.img-list {
  display: flex;
  flex-wrap: wrap;
  .el-image {
    margin: 0 10px 10px 0;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
  }
}

.el-button--mini.is-circle {
  padding: 5px;
}
</style>
